export default __webpack_public_path__ + "static/media/transferSuccess.4e293cd1.svg";